import Rest from '../Rest'

export default class LessonService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/lessons'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  /**
   * Planos de assinatura que dão direito a esta aula (escopos ALL/MOD/LES).
   * É o que a revisão mostra no lugar do preço quando a aula é exclusiva de
   * plano — "somente em planos" sem dizer quais não dá para conferir.
   */
  getCoveringPlans(id: Number) {
    return this.get(`/${id}/subscription_plans`)
  }

  // Discount Coupon
  getAllDiscountCoupon(id: Number) {
    return this.get(`/${id}/discount_coupons`).then(data => {
      return data
    })
  }
  addDiscountCoupon(id: Number, payload: any) {
    return this.post(`/${id}/discount_coupons`, {ids: payload}).then(data => {
      return data
    })
  }

  deleteDiscountCoupon(id: Number, entityId: Number) {
    return this.delete(`/${id}/discount_coupons/${entityId}`).then(data => {
      return data
    })
  }
  // --
  attachTeachers(id: Number, payload: any) {
    return this.post(`/${id}/teachers`, {ids: payload}).then(data => {
      return data
    })
  }

  deleteTeacher(id: Number, teacherId: Number) {
    return this.delete(`/${id}/teachers/${teacherId}`).then(data => {
      return data
    })
  }

  getAllTeachers(id: Number) {
    return this.get(`/${id}/teachers`).then(data => {
      return data
    })
  }
  // --Available Schedules
  getAllAvailableSchedules(id: Number) {
    return this.get(`/${id}/available_schedules`).then(data => {
      return data
    })
  }
  addAvailableSchedule(id: Number, payload: any) {
    return this.post(`/${id}/available_schedules`, payload).then(data => {
      return data
    })
  }
  updateAvailableSchedule(id: Number, entityId: Number, payload: any) {
    return this.put(`/${id}/available_schedules/${entityId}`, payload).then(data => {
      return data
    })
  }

  deleteAvailableSchedule(id: Number, entityId: Number) {
    return this.delete(`/${id}/available_schedules/${entityId}`).then(data => {
      return data
    })
  }

  deleteAvailableSchedules(id: Number, entityIds: Number) {
    return this.post(`/${id}/available_schedules/delete`, {ids: entityIds}).then(data => {
      return data
    })
  }

  // -- Occurrences (agenda da aula: vagas/bloqueio/cancelamento por data)
  getOccurrences(id: Number, startDate: String, days: Number = 14) {
    return this.get(`/${id}/occurrences?start_date=${startDate}&days=${days}`).then(data => {
      return data
    })
  }

  saveOccurrenceOverride(id: Number, payload: any) {
    return this.post(`/${id}/occurrences/override`, payload).then(data => {
      return data
    })
  }

  deleteOccurrenceOverride(id: Number, overrideId: Number) {
    return this.delete(`/${id}/occurrences/override/${overrideId}`).then(data => {
      return data
    })
  }

  cancelOccurrence(id: Number, payload: any) {
    return this.post(`/${id}/occurrences/cancel`, payload).then(data => {
      return data
    })
  }

  /**
   * Move a sessão do dia inteira para outro horário, com todos os alunos numa
   * transação só. Diferente de `CalendarService.rescheduleEvent`, que remarca um
   * aluno de cada vez.
   */
  rescheduleOccurrence(id: Number, payload: any) {
    return this.post(`/${id}/occurrences/reschedule`, payload)
  }

  /** Check-in da turma: só os ids enviados viram sessão realizada. */
  checkinOccurrence(id: Number, payload: any) {
    return this.post(`/${id}/occurrences/checkin`, payload)
  }

  // --- autorização nominal de vaga (acima do limite, para um aluno só) ---

  getSeatGrants(id: Number, date: string, startTime: string, endTime: string) {
    return this.get(`/${id}/seat_grants?date=${date}&start_time=${startTime}&end_time=${endTime}`)
  }

  createSeatGrant(id: Number, payload: any) {
    return this.post(`/${id}/seat_grants`, payload)
  }

  revokeSeatGrant(id: Number, grantId: Number) {
    return this.delete(`/${id}/seat_grants/${grantId}`)
  }
}
